import { FC, useState, useEffect } from "react";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { usePluginContext } from "../../../../system/providers/plugin";
import { LoadingStatus, } from "../../../../@types/enumsGlobal";
import { ToolbarWrapper } from "../../../../components/plugins/ToolbarWrapper";
import { DefaultPricingModelCommandsPanel } from "../../../../components/commandsPanels/DefaultPricingModelCommandsPanel";
import { PricingAdpriceScaleDataProvider } from "../../../../Services/DataProviders/PricingAdpriceScaleDataProvider";
import PricingAdpriceScaleCreatorModal from "../selectorModal/PricingAdpriceScaleCreatorModal";
import { IPricingAdpriceScaleDTO, IPricingAdpriceScaleViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingAdpriceScale";
import { PricingConditionDataProvider } from "../../../../Services/DataProviders/PricingConditionDataProvider";
import { IPricingConditionDTO, IPricingConditionViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingCondition";

export interface ICopyGridProps extends ISelectorGridProps {
    gridId: string,
    plugin: IPluginSettings,
    baseGridFilter?: IGridFilter,
    id?: string
}

export interface IPricingAdpriceScaleDTOAndIdGlobal extends IPricingAdpriceScaleDTO {
    idPricingAdpriceScaleGlobal?: string
}

interface IModalStateProps {
    isOpen: boolean,
    modalData: IPricingAdpriceScaleDTOAndIdGlobal,
    variant: "create" | "edit" | "copy";
}

export const initialPricingAdpriceScale: IPricingAdpriceScaleDTOAndIdGlobal = {
    adpricePercent: 0,
    conditionMethod: 'И',
    idPricingAdpriceScaleTypeGlobal: '',
    includeSupplierAdprice: false,
    maxPercent: 0,
    minPercent: 0,
    priority: 0,
    idPricingAdpriceScaleGlobal: ''
}

const PricingAdpriceScaleGrid: FC<ICopyGridProps> = (props) => {

    const pluginCtx = usePluginContext();
    const appCtx = useAppContext()
    const pricingAdpriceScaleDataProviderDP = new PricingAdpriceScaleDataProvider(appCtx.coreApiService)
    const pricingConditionDataProvider = new PricingConditionDataProvider(appCtx.coreApiService)

    const [data, setData] = useState<IPricingAdpriceScaleViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>();
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [blockButton, setBlockButton] = useState<boolean>(true);

    const masterGridSelectedItem = pluginCtx.masterGrid.selectedItem?.idGlobal;

    useEffect(() => {
        getView();
    }, [masterGridSelectedItem, gridFilter])

    const [modalState, setModalState] = useState<IModalStateProps>({
        isOpen: false,
        modalData: initialPricingAdpriceScale,
        variant: 'create'
    });

    const getView = () => {
        if (masterGridSelectedItem) {
            setSelectedItem(undefined);
            pricingAdpriceScaleDataProviderDP.getView({
                ...gridFilter,
                columnFilters: [
                    {
                        name: "idPricingAdpriceScaleTypeGlobal",
                        operator: 'Eq',
                        value: masterGridSelectedItem
                    }
                ]
            }, (data, totalCount) => {
                setData(data)
                setTotalCount(totalCount)
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            })
        }
    }

    const getMaxPriority = () => {
        if (data.length === 0) return 1;

        let maxPriority = data[0]?.priority;
        for (let i = 1; i < data.length; i++) {
            if (data[i].priority > maxPriority) {
                maxPriority = data[i].priority;
            }
        }
        return maxPriority + 1;
    }

    const variantSaveData = (saveData: IPricingAdpriceScaleDTO, idPricingAdpriceScaleGlobal: string | undefined) => {
        
        if (idPricingAdpriceScaleGlobal) {
            pricingAdpriceScaleDataProviderDP.update(idPricingAdpriceScaleGlobal as string, saveData, () => {
                setModalState(prev => ({ ...prev, isOpen: false }))
                getView();
            });
        } else {
            pricingAdpriceScaleDataProviderDP.create(saveData, (idGlobal) => {
                setModalState(prev => ({ ...prev, isOpen: false }));
                getView();
            })
        }
    }

    return (
        <>
            <ToolbarWrapper>
                <DefaultPricingModelCommandsPanel
                    add={{
                        onClick: () => {
                            if (masterGridSelectedItem) {
                                setModalState({
                                    isOpen: true,
                                    modalData: { ...initialPricingAdpriceScale, idPricingAdpriceScaleTypeGlobal: masterGridSelectedItem, priority: getMaxPriority() }, variant: 'create'
                                });
                            }
                        },
                    }}
                    edit={{
                        onClick: () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);
                                pricingAdpriceScaleDataProviderDP.getById(selectedItem.idGlobal, async (entity) => {
                                    setModalState({ isOpen: true, modalData: { ...entity, idPricingAdpriceScaleGlobal: selectedItem.idGlobal }, variant: 'edit' });
                                    setBlockButton(true);
                                })
                            }
                        },
                        disabled: !selectedItem
                    }}
                    copy={{
                        onClick: async () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);
                                // 1) Получаем копию документа
                                const entityCopy = await new Promise<IPricingAdpriceScaleDTO>((resolve) => {
                                    pricingAdpriceScaleDataProviderDP.getById(selectedItem.idGlobal, (entity) => resolve(entity));
                                });
                                const copyEntity = { ...entityCopy, idPricingAdpriceScaleGlobal: '', priority: getMaxPriority()};


                                //2) Получаем все условия вью.
                                const viewDataPricing = await new Promise<IPricingConditionViewDTO[]>((resolve) => {
                                    pricingConditionDataProvider.getView({
                                        ...gridFilter, columnFilters: [{
                                            name: 'idPricingAdpriceScaleGlobal',
                                            operator: 'Eq',
                                            value: selectedItem.idGlobal
                                        }]
                                    }, (data) => resolve(data));
                                });


                                if (viewDataPricing.length > 0) {
                                    //3 если есть условия то создаем новую позицию.

                                    const createdIdPricingAdpriceScaleGlobal = await new Promise<string>((resolve) => {
                                        pricingAdpriceScaleDataProviderDP.create(copyEntity, (idPricingAdpriceScaleGlobalRequest) => {
                                            resolve(idPricingAdpriceScaleGlobalRequest);
                                        })
                                    })

                                    //4 Получаем все условия по вьюхе и добавляем новый idScaleGlobal
                                    const promisesCopyConditions = viewDataPricing.map((elemGet) => {
                                        return new Promise<IPricingConditionDTO>((resolve, reject) => {

                                            try {
                                                pricingConditionDataProvider.getById(elemGet.idGlobal, (condition) => {
                                                    resolve({
                                                        compareTypeEnum: condition.compareTypeEnum,
                                                        paramValue: condition.paramValue,
                                                        paramValueGlobal: '00000000-0000-0000-0000-000000000000',
                                                        paramValueChar: condition.paramValueChar,
                                                        paramValueRef: condition.paramValueRef,
                                                        idPricingConditionParamGlobal: condition.idPricingConditionParamGlobal,
                                                        idPricingAdpriceScaleGlobal: createdIdPricingAdpriceScaleGlobal,
                                                        idPricingMinAdpriceSchemaGlobal: condition.idPricingMinAdpriceSchemaGlobal,
                                                        idPricingRoundScaleGlobal: condition.idPricingRoundScaleGlobal,
                                                        idPricingExtremeAdpriceSchemaGlobal: condition.idPricingExtremeAdpriceSchemaGlobal,
                                                        idPricingPriceCalcSchemaGlobal: condition.idPricingPriceCalcSchemaGlobal,
                                                        ids: condition.ids
                                                    });

                                                })
                                            } catch (error) {
                                                reject(error)
                                            }

                                        });
                                    });

                                    try {
                                        const copyConditions = await Promise.all(promisesCopyConditions);
                                        //5 Создаем новую копию условий с новым ScaleIdGlobal
                                        const promisesCreateConditions = copyConditions.map((newCondition) => {
                                            // Проверка объекта на свойство ids, если данный объект не содержит ids значит будет создавать без ids
                                            const { ids, ...newPricingConditionData } = newCondition;
                                            const checkCondition = newCondition.ids === null || newCondition.ids.length === 0 ? newPricingConditionData : newCondition

                                            return new Promise<string>((resolve) => {
                                                pricingConditionDataProvider.create(checkCondition as any, (idGlobal) => {
                                                    resolve(idGlobal);
                                                })

                                            });
                                        });
                                        const createConditions = await Promise.all(promisesCreateConditions);

                                        if (createConditions) {
                                            setBlockButton(true);
                                            setModalState({
                                                isOpen: true,
                                                modalData: {
                                                    ...copyEntity,
                                                    idPricingAdpriceScaleGlobal: createdIdPricingAdpriceScaleGlobal
                                                },
                                                variant: 'copy'
                                            });
                                        }

                                    } catch (error) {
                                        throw new Error('Ошибка при генерации условий');
                                    }


                                } else {
                                    setBlockButton(true);
                                    setModalState({
                                        isOpen: true,
                                        modalData: {
                                            ...copyEntity,
                                            idPricingAdpriceScaleGlobal: ''
                                        },
                                        variant: 'copy'
                                    });
                                }
                            }
                        },
                        disabled: !selectedItem
                    }}
                    delete={{
                        onClick: () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);
                                pricingAdpriceScaleDataProviderDP.markDelete(selectedItem.idGlobal, () => {
                                    setBlockButton(true);
                                    getView();
                                });
                            }
                        },
                        disabled: !selectedItem
                    }}
                    refresh={{
                        onClick: () => {
                            getView();
                        }
                    }}
                    permission={props.plugin.permission}
                />
            </ToolbarWrapper>
            {
                <DefaultGrid
                    gridId={props.gridId}
                    data={data}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    singleDirectory
                    totalCount={totalCount}
                    filter={gridFilter}
                    dataProvider={pricingAdpriceScaleDataProviderDP}
                    plugin={props.plugin}
                    selectedItem={selectedItem}
                    onDoubleClick={(row) => props.onDoubleClick?.(row)}
                    onSelect={(row) => {
                        setSelectedItem(row ? row : undefined)
                        props.onSelect?.(row)
                    }}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    onEnter={() => setViewState("edit")}
                />
            }
            {
                modalState.isOpen &&
                <PricingAdpriceScaleCreatorModal
                    viewDataForValidatePriority={data}
                    data={modalState.modalData}
                    variant={modalState.variant}
                    save={(saveData, idPricingAdpriceScaleGlobal) => {

                        if (modalState.variant === 'edit') {
                            variantSaveData(saveData, selectedItem?.idGlobal)
                        }
                        else if (modalState.variant === 'copy') {
                            variantSaveData(saveData, idPricingAdpriceScaleGlobal)
                        }
                        else if (modalState.variant === 'create') {
                            variantSaveData(saveData, idPricingAdpriceScaleGlobal)
                        }
                    }}
                    cancel={() => {
                        if (modalState.variant === 'create' || modalState.variant === 'copy') {
                            getView();
                        }
                        setModalState(prev => ({ ...prev, isOpen: false }))
                    }}
                />
            }
        </>
    )
}

export default PricingAdpriceScaleGrid